import { StateToken } from '@ngxs/store';
import type { FormStateModel } from './form.types';

/**
 * Identifies the form state by name so selectors can declare a dependency on it
 * without importing the state class.
 *
 * Importing `FormState` into form.selectors.ts creates a runtime import cycle
 * (form.selectors -> form.state -> subscription/mbb components -> form.selectors).
 * `@Selector([...])` resolves its dependencies while the module is evaluated, so
 * whenever that cycle was entered at form.state.ts the decorators recorded an
 * `undefined` dependency and every read of a FormSelectors selector later failed
 * with "Cannot read properties of undefined (reading 'NGXS_SELECTOR_META')".
 * A token has no such dependency: it resolves the state slice by name at runtime.
 */
export const FORM_STATE_TOKEN = new StateToken<FormStateModel>('formState');
